export default __webpack_public_path__ + "c2baf77dc88a4e3d4e8a2e2d30f86da9.woff2";